import React from 'react';
import PropTypes from 'prop-types';

const EffectTextPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M8.143 18.242h3.487l-2.055-6.478-1.907 5.822a.5.5 0 0 0 .475.656zM8.018 8h3.18a.5.5 0 0 1 .472.333l5.476 15.463a.5.5 0 0 1-.471.667h-2.656a.5.5 0 0 1-.477-.35l-.951-3.034H6.526l-1.024 3.043a.5.5 0 0 1-.474.34H2.5a.5.5 0 0 1-.47-.667L7.546 8.332A.5.5 0 0 1 8.017 8zm17.908 10.543a3.459 3.459 0 0 1-.608.307 5.09 5.09 0 0 1-.844.218l-.714.134c-.67.12-1.15.265-1.441.436-.492.29-.737.74-.737 1.351 0 .544.15.937.452 1.179.302.242.668.363 1.1.363.685 0 1.316-.202 1.893-.604.577-.402.877-1.135.9-2.2v-1.184zm-1.932-1.485c.588-.075 1.009-.168 1.262-.28.454-.193.681-.495.681-.904 0-.499-.173-.843-.519-1.033-.346-.19-.854-.285-1.524-.285-.752 0-1.285.186-1.598.558-.223.276-.372.648-.446 1.117h-3.072c.067-1.064.365-1.94.894-2.624.841-1.073 2.286-1.609 4.333-1.609 1.333 0 2.517.265 3.552.793 1.035.529 1.552 1.527 1.552 2.994v5.584c0 .387.008.856.023 1.407.022.417.085.7.19.849.104.149.26.272.469.369 0 .259-.21.469-.47.469h-2.993a3.545 3.545 0 0 1-.2-.693 8.348 8.348 0 0 1-.09-.737 6.54 6.54 0 0 1-1.519 1.217c-.685.395-1.46.592-2.323.592-1.102 0-2.012-.314-2.73-.943-.72-.63-1.079-1.521-1.079-2.675 0-1.497.577-2.58 1.732-3.25.632-.365 1.563-.626 2.792-.782l1.083-.134z"
    />
  );
};

EffectTextPath.propTypes = {
  fill: PropTypes.string,
};

export default EffectTextPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/effects/effect-text.jsx